"use client";

import React, { PropsWithChildren, useEffect, useMemo } from "react";
import { useAuth } from "@/lib/auth";
import { Bugsnag, bugsnagStarted } from "@/lib/bugsnag-init";
import { logger } from "@/lib/logger";

export function BugsnagErrorBoundaryProvider({ children }: PropsWithChildren) {
  // Auth ContextからIDが取れたら、setUserする
  const { ID } = useAuth();
  useEffect(() => {
    if (!bugsnagStarted) {
      return;
    }
    if (ID) {
      Bugsnag.setUser(ID);
    } else {
      Bugsnag.setUser(null);
    }
  }, [ID]);

  // ErrorBoundaryを作成してラップする
  const ErrorBoundary = useMemo(() => {
    if (bugsnagStarted && typeof window !== "undefined") {
      const reactPlugin = Bugsnag.getPlugin("react");
      if (reactPlugin) {
        return reactPlugin.createErrorBoundary(React);
      }
      logger.warn(
        "Bugsnag React Plugin not found client-side. ErrorBoundary will not be available.",
      );
    }
    return null;
  }, []);

  if (ErrorBoundary) {
    return <ErrorBoundary>{children}</ErrorBoundary>;
  }
  return <>{children}</>;
}
